export default __webpack_public_path__ + "static/media/skimMilkChocolatePowder.985c56ce.jpg";